var _rect, _rect2, _g, _rect3, _text, _text2, _rect4, _circle, _circle2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 600,
    viewBox: "0 0 840 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 840,
    height: 600,
    fill: "#1a1a1a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 320,
    height: 320,
    rx: 24,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 112,
    width: 56,
    height: 56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 112,
    width: 56,
    height: 56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 124,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 280,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 292,
    width: 56,
    height: 56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 304,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 100,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 140,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 188,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 200,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 248,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 200,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 248,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 320,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 320,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 280,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 336,
    width: 24,
    height: 24
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 90,
    width: 310,
    height: 180,
    rx: 20,
    fill: "#fff537"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 165,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#111"
  }, "Generate")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 205,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 18,
    fill: "#333"
  }, "Create QR in seconds")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 300,
    width: 310,
    height: 180,
    rx: 20,
    fill: "#2b2b2b",
    stroke: "#fff537",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 372,
    r: 42,
    fill: "none",
    stroke: "#fff537",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 372,
    r: 10,
    fill: "#fff537"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 445,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 18,
    fill: "#fff"
  }, "Scan with camera")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrProject);
export default __webpack_public_path__ + "static/media/qr-project.dbc2e18629783e6c3b69cce404f8e2e2.svg";
export { ForwardRef as ReactComponent };